module.exports = __webpack_public_path__ + "img/empty-box.2b02f01d.webp";